module.exports = __webpack_public_path__ + "img/step2.c6f250b8.svg";